export var RiskLevel;
(function (RiskLevel) {
    RiskLevel["RISK_LEVEL_LOW"] = "LOW";
    RiskLevel["RISK_LEVEL_MEDIUM"] = "MEDIUM";
    RiskLevel["RISK_LEVEL_HIGH"] = "HIGH";
    RiskLevel["RISK_LEVEL_CRITICAL"] = "CRITICAL";
})(RiskLevel || (RiskLevel = {}));
